import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";
import Header from "../Components/Header";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import axios from "../api/axios";

export default function Register() {
  const [name, setName] = useState("");
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();
    setError("");

    if (password !== passwordConfirmation) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    const register_by = emailOrPhone.includes("@") ? "email" : "phone";

    axios.post("/auth/signup", {
      name: name,
      email_or_phone: emailOrPhone,
      password: password,
      password_confirmation: passwordConfirmation,
      register_by: register_by
    })
    .then((response) => {
      if (response.data.result) {
        // On successful registration, automatically authenticate and log in
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/dashboard");
      } else {
        const msg = Array.isArray(response.data.message) 
          ? response.data.message.join(" ") 
          : response.data.message;
        setError(msg || "Registration failed.");
      }
    })
    .catch((error) => {
      setError(error.response?.data?.message || error.message || "An error occurred during registration.");
      console.error(error);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <Header mode="dark" />
      <div className="container-fluid">
        <div className="login-wrapper d-flex align-items-center justify-content-center">
          <form className="login-card text-center" onSubmit={handleRegister}>
            <h3 className="login-title">Create an account</h3>

            {error && <div className="alert alert-danger">{error}</div>}

            <input
              type="text"
              className="form-control login-input"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <input
              type="text"
              className="form-control login-input"
              placeholder="Email or Phone Number"
              value={emailOrPhone}
              onChange={(e) => setEmailOrPhone(e.target.value)}
              required
            />

            <input
              type="password"
              className="form-control login-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <input
              type="password"
              className="form-control login-input"
              placeholder="Confirm Password"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
            />

            <div className="d-flex justify-content-between align-items-center login-options">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" required id="agreeTerms" />
                <label className="form-check-label" htmlFor="agreeTerms">
                  By signing up you agree to our terms and conditions.
                </label>
              </div>
            </div>

            <button type="submit" className="btn login-btn w-100" disabled={loading}>
              {loading ? "Registering..." : "Create Account"}
            </button>

            <p className="register-text">Already have an account?</p>

            <Link to="/login">
              <p className="register-link">Log In</p>
            </Link>
          </form>
        </div>
      </div>
      <Feature />
      <Footer />
    </>
  );
}
